import { memo } from "react";
import moment from "moment-timezone";
import { ISession } from "../../../../models/session";
import { formatDay, formatMonth, formatTime } from "../utils/utils";
import SessionTypeIcon from "./SessionTypeIcon";
import styles from "./index.module.scss";
import RelatedSessionsMenu from "./RelatedSessionsMenu";

moment.tz.setDefault("Asia/Jerusalem");

interface SpecialSessionProps {
    session: ISession;
    language: string
}

const SpecialSession = ({ session, language }: SpecialSessionProps) => {
    const {
        _id: sessionId,
        startDate,
        sessionType,
        sessionTitle,
        related,
        startTime,
        endTime
    } = session;

    const formatSessionDateTime = () => {
        const startDateObj = new Date(startDate);
        const formattedDay = formatDay(startDateObj);
        const formattedMonth = formatMonth(startDateObj, language);
        const formattedStartTime = formatTime(startTime, language);
        const formattedEndTime = formatTime(endTime, language);

        return `${formattedMonth} ${formattedDay}   ${formattedStartTime}-${formattedEndTime}`;
    };

    return (
        <div
            className={styles.container}
            key={sessionId}
            id={sessionId}>
            <div className={styles.content}>
                <SessionTypeIcon type={sessionType} />
                <div className={styles.details}>
                    <div className={styles.title}>{sessionTitle}</div>
                    <div className={styles.date}>
                        <div>
                            {formatSessionDateTime()}
                        </div>
                        {related && related.length > 0 && <RelatedSessionsMenu related={related} />}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(SpecialSession);
